import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import type { OrgProps } from '@/types/org';

export function useOrg() {
    const page = usePage<OrgProps>();
    const staff = computed(() => page.props.orgAuth);
    const can = (permission: string) =>
        staff.value?.permissions.includes(permission) ?? false;
    const publicUrl = (route: { url: string }) =>
        new URL(route.url, page.props.publicSiteUrl).href;
    return { staff, can, publicUrl };
}
